import BaseQueryStore from 'core/stores/BaseQueryStore';
import { action, makeObservable, observable } from 'mobx';

class BaseStore extends BaseQueryStore {
	@observable item = null;
	response = null;
	service = null;

	constructor(service) {
		super();
		makeObservable(this);
		this.service = service;
	}

	@action
	find = async filter => {
		const response = await this.service.find(filter);
		this.response = response.data;
		return response.data;
	};

	@action
	update = async (resource, sourceOfChange = '') => {
		await this.service.update(resource, sourceOfChange);
	};

	@action
	create = async (resource, sourceOfChange = '') => {
		const response = await this.service.create(resource, sourceOfChange);
		this.response = response.data;
		return response.data;
	};

	@action
	get = async (id, options = {}) => {
		const response = await this.service.get(id, options);
		this.response = response.data;
		return response.data;
	};

	@action
	delete = async resource => {
		resource = { id: resource.id };
		await this.service.delete(resource);
	};

	@action
	setResponseItem = item => {
		this.response.item = item;
	};

	@action
	exportToCsv = async filter => {
		return await this.service.exportToCsv(filter);
	};
}

export default BaseStore;
